// extracted by mini-css-extract-plugin
export var alternate = "_o-h";
export var black = "_o-3";
export var blue = "_o-d";
export var blueLight = "_o-c";
export var brand = "_o-7";
export var error = "_o-9";
export var gray = "_o-6";
export var grayBlue = "_o-b";
export var iconWrapper = "_o-4";
export var indigo = "_o-e";
export var orange = "_o-g";
export var pink = "_o-f";
export var primary = "_o-0";
export var purple = "_o-8";
export var success = "_o-5";
export var warning = "_o-a";
export var white = "_o-1";
export var whiteSuccess = "_o-2";